var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "50px",
    zoomAndPan: "magnify",
    viewBox: "0 0 1050 1049.999947",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4d994ead20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 164.347656 10.675781 L 961.597656 10.675781 L 961.597656 1039.675781 L 164.347656 1039.675781 Z M 164.347656 10.675781 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4d994ead20)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0749E0",
    d: "M 961.539062 961.496094 C 961.539062 687.085938 782.941406 464.765625 562.945312 464.765625 C 342.949219 464.765625 164.347656 687.085938 164.347656 961.496094 C 164.347656 1004.285156 342.949219 1039.167969 562.945312 1039.167969 C 782.941406 1039.167969 961.539062 1004.285156 961.539062 961.496094 Z M 562.945312 10.820312 C 682.941406 10.820312 780.148438 108.027344 780.148438 228.023438 C 780.148438 348.023438 682.941406 445.230469 562.945312 445.230469 C 442.949219 445.230469 345.742188 348.023438 345.742188 228.023438 C 345.742188 108.027344 442.949219 10.820312 562.945312 10.820312 Z M 562.945312 10.820312 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacto);
export default __webpack_public_path__ + "static/media/contacto.bdb24bd3e70da3c3a379114449b0e935.svg";
export { ForwardRef as ReactComponent };